import axios from "axios";
import { getAppCheckToken } from "./firebase";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(
  async (config) => {
    try {
      // Only attach App Check token in production
      if (process.env.NODE_ENV !== "development") {
        const token = await getAppCheckToken();
        if (token) {
          config.headers["X-Firebase-AppCheck"] = token;
        }
      }
    } catch (err) {
      console.warn("Failed to attach App Check token:", err);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
